import { SupportsRosterCtrl } from './supports-roster.controller';

export const SupportsRosterComponent = {
  controller: SupportsRosterCtrl,
  bindings: {
    studentSupports$: '<',
    attendanceRecords: '<',
  },
  template: require('./supports-roster.html'),
};
